<div class="predefined-message-dialog">
    <app-dialog-title
        [title]="mode === 'add'
            ? ('pages.config-all.config-requests.predefinedMessages.dialog.addTitle' | translate)
            : ('pages.config-all.config-requests.predefinedMessages.dialog.editTitle' | translate)"
        (close)="cancel()">
    </app-dialog-title>

    <mat-dialog-content>
        <app-bciti-tabs>
            <app-bciti-tab *ngFor="let lang of langs" [title]="'pages.config-all.config-requests.predefinedMessages.langs.' + lang | translate">
                <div class="form-fields">
                    <app-form-textarea
                        label="{{ 'pages.config-all.config-requests.predefinedMessages.dialog.messageLabel' | translate }}"
                        placeholder="{{ 'pages.config-all.config-requests.predefinedMessages.dialog.messagePlaceholder.' + lang | translate }}"
                        [formControl]="getControl(lang)"
                        [rows]="4">
                        <app-form-error *ngIf="getControl(lang).touched && getControl(lang).hasError('required')">
                            {{ 'pages.config-all.config-requests.predefinedMessages.dialog.messageRequired' | translate }}
                        </app-form-error>
                    </app-form-textarea>
                </div>
            </app-bciti-tab>
        </app-bciti-tabs>
    </mat-dialog-content>

    <footer class="dialog-footer">
        <button class="bciti-button bciti-button--black-inversed" (click)="cancel()">
            {{ 'pages.config-all.config-requests.predefinedMessages.dialog.cancelButton' | translate }}
        </button>
        <button class="bciti-button bciti-button--blue" (click)="submit()">
            {{ 'pages.config-all.config-requests.predefinedMessages.dialog.submitButton' | translate }}
        </button>
    </footer>
</div>
